module.exports = "<div ng-include=\"'menu-top'\"></div>\n<div id=\"home\" ng-include=\"'bloque1'\"></div>\n<div id=\"info\" ng-include=\"'bloque2'\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/header/header.html
// module id = 535
// module chunks = 0